<template>
    <div>
        <h5 class="text-uppercase font-weight-bold ">My client list</h5>

        <div class="position-relative">
            <div class="list">
                <div
                    class="email bg-white list-item p-2 border-bottom"
                    v-if="['professional_silver'].includes(organization.type)"
                >
                    <div class="row">
                        <div class="col-12" @click="showAddClientModal()">
                            <p
                                class="mb-0 font-weight-bold"
                                v-tooltip="
                                    canAddClient
                                        ? null
                                        : 'Sorry, you do not have permission to create new clients.'
                                "
                                :class="
                                    canAddClient
                                        ? 'text-primary cursor-pointer'
                                        : 'text-muted cursor-not-allowed'
                                "
                            >
                                <i class="fa fa-plus-circle mr-2"></i>Click here to create new
                                client.
                            </p>
                        </div>
                    </div>

                    <div class="row">
                        <div
                            class="col-12"
                            @click.stop="showAddClientFromOrgModal()"
                            v-tooltip="
                                canAddClient
                                    ? null
                                    : 'Sorry, you do not have permission to add clients from this organization.'
                            "
                            :class="
                                canAddClient
                                    ? 'text-primary cursor-pointer'
                                    : 'text-muted cursor-not-allowed'
                            "
                        >
                            <p class="mb-0 font-weight-bold">
                                <i class="fa fa-plus-circle mr-2"></i>Click to add client from this
                                organization.
                            </p>
                        </div>
                    </div>
                </div>

                <div class="email bg-white list-item p-2">
                    <div class="row">
                        <div class="col d-flex">
                            <input
                                id="filter-string"
                                type="text"
                                class="form-control-sm form-control"
                                v-model="filterString"
                                placeholder="Filter by first or last name"
                                autocomplete="off"
                            />
                            <button
                                class="btn btn-link btn-sm text-primary"
                                @click="filterString = ''"
                            >
                                Clear
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="d-flex p-2 list-item bg-white cursor-pointer"
                v-for="(c, i) in filteredUserClientsByOrganization.filter(clients =>
                    clients.name.toLowerCase().includes(filterString.toLowerCase().trim())
                )"
                :key="c.name"
            >
                <div @click="helpers.goLink(`/patients/${c.id}/goals`)">
                    <img class="client-image" :src="c.profile_photo_url" />
                </div>
                <div class="ml-3 d-block" @click="helpers.goLink(`/patients/${c.id}/goals`)">
                    <h4 class="p-0 m-0 font-italic">{{ c.name }}</h4>
                    <p class="p-0 m-0 font-italic">
                        Last Updated: {{ moment(c.updated_at).format("MM/DD/YYYY") }}
                    </p>
                </div>
                <!-- <div class="ml-auto mr-2 d-flex flex-column justify-content-center">
                    <div class="flex flex-column justify-content-center">
                        <i class="fa fa-ellipsis-h fa-lg" style="cursor: pointer;" @click.stop="showContextMenu(c)"></i>
                    </div>
                </div>-->
                <div class="ml-auto d-flex justify-content-end align-items-center">
                    <div class="dropdown text-right">
                        <button
                            class="btn btn-sm btn-link text-black"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <i class="fa fa-ellipsis-v"></i>
                        </button>
                        <div
                            class="dropdown-menu dropdown-menu-right"
                            aria-labelledby="delete-recurring"
                        >
                            <a
                                :class="
                                    canAddClient
                                        ? 'cursor-pointer'
                                        : 'text-light cursor-not-allowed'
                                "
                                class="dropdown-item small actions"
                                @click="canAddClient ? showAssignResource(c) : null"
                                >{{ c.first_name }} Therapist Connections
                            </a>
                            <a class="dropdown-item small actions" @click="detailsClient(c)">
                                Edit
                            </a>
                            <a
                                :class="
                                    canAddClient
                                        ? 'cursor-pointer'
                                        : 'text-light cursor-not-allowed'
                                "
                                class="dropdown-item small actions"
                                @click="canAddClient ? detachClient(c) : null"
                                v-html="
                                    loading
                                        ? `<i class='fa fa-spin fa-circle-o-notch mr-2'></i> Saving...`
                                        : 'Disconnect'
                                "
                            >
                            </a>
                            <a
                                :class="
                                    canAddClient
                                        ? 'text-danger cursor-pointer'
                                        : 'text-light cursor-not-allowed'
                                "
                                class="dropdown-item small actions"
                                @click="canAddClient ? confirmDelete(c) : null"
                                v-html="
                                    loading
                                        ? `<i class='fa fa-spin fa-circle-o-notch mr-2'></i> Saving...`
                                        : 'Delete'
                                "
                            ></a>

                            <!-- <a class="cursor-pointer dropdown-item small actions"
                               :class="canEditStaff ? '' : 'text-muted cursor-not-allowed'"
                               @click.stop="canEditStaff ? showAssignResource(u) : null">{{u.first_name}} Client Connections</a>
                            <a class="cursor-pointer dropdown-item small actions text-danger"
                               :class="canEditStaff ? 'text-danger' : 'text-muted cursor-not-allowed'"
                               @click.stop="canEditStaff ? showRemoveTeamModal(u) : null">Remove {{u.first_name}} From Team</a>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal-component
            :id="'client-list-widget-modal'"
            :visible="modal.visible"
            :title="modal.title"
            :size="modal.size"
            @close="resetModal()"
        >
            <!--ADD CLIENT INVITE-->
            <div v-if="modal.type === 0">
                <div class="w-100 position-relative">
                    <input
                        type="text"
                        id="first-name-0"
                        class="form-control form-control my-1"
                        v-model="newClient.first_name"
                        placeholder="First Name"
                        required
                    />
                    <input
                        type="text"
                        id="last-name-0"
                        class="form-control form-control my-1"
                        v-model="newClient.last_name"
                        placeholder="Last Name"
                        required
                    />
                    <input
                        type="text"
                        id="parent-email-0"
                        class="form-control form-control my-1"
                        v-model="newClient.parent_email"
                        placeholder="Parent E-mail Address (optional)"
                    />
                </div>
                <transition name="simple-fade" mode="out-in">
                    <button
                        class="btn btn-primary font-weight-bold text-uppercase text-white my-3"
                        @click="createClient()"
                        v-html="
                            loading
                                ? `<i class='fa fa-spin fa-circle-o-notch mr-2'></i> Saving...`
                                : 'Add Client'
                        "
                    ></button>
                </transition>
            </div>
            <!--CLIENT DETAILS-->
            <div v-if="modal.type === 1">
                <div class="row">
                    <div class="col-4">
                        <patient-detail-photo-widget :patient="selectedAssignee"
                            ><button class="btn btn-link text-primary">
                                > Upload image
                            </button></patient-detail-photo-widget
                        >
                    </div>
                    <div class="col-8">
                        <input
                            type="text"
                            id="first-name"
                            class="form-control form-control my-1"
                            v-model="selectedAssignee.first_name"
                            placeholder="First Name"
                            required
                        />
                        <input
                            type="text"
                            id="last-name"
                            class="form-control form-control my-1"
                            v-model="selectedAssignee.last_name"
                            placeholder="Last Name"
                            required
                        />
                        <input
                            type="text"
                            id="parent-email"
                            class="form-control form-control my-1"
                            v-model="selectedAssignee.parent_email"
                            placeholder="Parent E-mail Address (optional)"
                        />
                        <div class="d-flex flex-row justify-content-end my-3">
                            <button
                                key="update"
                                class="btn btn-sm btn-primary font-weight-bold text-uppercase text-white my-3 mx-2"
                                @click="updateClient()"
                                v-html="
                                    loading
                                        ? `<i class='fa fa-spin fa-circle-o-notch mr-2'></i> Saving...`
                                        : 'Update'
                                "
                            ></button>
                        </div>
                    </div>
                </div>
            </div>

            <!--CONFIRM DELETE-->
            <div v-if="modal.type === 2">
                <p class="text-center">
                    Are you sure you want to permanently remove {{ selectedAssignee.name }} from the
                    database?
                </p>
                <div class="d-flex w-100 justify-content-between align-items-center py-3">
                    <a
                        class="small link-primary text-primary font-weight-bold text-uppercase"
                        @click="resetModal()"
                        >No, don't remove</a
                    >
                    <a
                        class="btn btn-sm btn-danger font-weight-bold text-uppercase text-white"
                        @click="deleteClient(selectedAssignee)"
                        v-html="
                            loading
                                ? `<i class='fa fa-spin fa-circle-o-notch mr-2'></i> Saving...`
                                : 'Yes, remove'
                        "
                    ></a>
                </div>
            </div>

            <!--ERROR MESSAGE-->
            <div v-if="modal.type === 4">
                <div class="row">
                    <div class="col-3 d-flex justify-content-center align-items-center">
                        <i class="fa fa-2x fa-exclamation-triangle"></i>
                    </div>
                    <div class="col-9 d-flex justify-content-center align-items-center">
                        <div>
                            <p class="">
                                It was not possible to complete the requested operation. If this
                                error persists, please
                                <a href="/contact" target="_blank">contact our support</a>.
                            </p>
                            <small v-if="errorMessage">Error code: {{ errorMessage }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </modal-component>

        <delete-confirmation
            :id="'client-list-widget-delete'"
            :visible="deleteConfirmationVisible"
            :button-text="'Yes, delete patient'"
            @confirm="deleteClient(deletePayload)"
            @close="resetDelete()"
        >
            <template slot="title">
                Remove {{ helpers._get(deletePayload, "name", "patient") }}?
            </template>
            <template slot="description">
                <p>
                    {{ helpers._get(deletePayload, "name", "The patient") }} will be permanently
                    removed from the database.
                </p>
            </template>
        </delete-confirmation>

        <!-- TODO: convert other modals to be their own separate components -->
        <add-client-from-org-modal
            :user="user"
            :organization="organization"
            :currentClients="filteredUserClientsByOrganization"
            :visible="isAddClientFromOrgModalVisible"
            :handleClose="hideAddClientFromOrgModal"
        ></add-client-from-org-modal>

        <assign-resource
            :key="'therapists'"
            :user="user"
            :organization="organization"
            :resource="'therapists'"
            :selectedAssignee="selectedAssignee"
            :visible="isAssignResourceVisible"
            @handle-close="hideAssignResource"
            @update-resource="fetchFilteredUserClientsByOrganization()"
        ></assign-resource>
    </div>
</template>

<script>
import ModalComponent from "../../ui/ModalComponent";
import PatientDetailPhotoWidget from "../PatientDetailPhotoWidget";
import AddClientFromOrgModal from "./AddClientFromOrgModal";
import AssignResource from "../../widgets/AssignResource";
import { helpers } from "../../../plugins/helpers";
import { permissions } from "../../../plugins/permissions";
import { deleteConfirmation } from "../../../plugins/deleteConfirmation";

export default {
    name: "ClientListWidget",
    props: ["user", "organization"],
    mixins: [permissions, deleteConfirmation],
    components: {
        ModalComponent,
        PatientDetailPhotoWidget,
        AddClientFromOrgModal,
        AssignResource,
    },
    data() {
        return {
            helpers,
            newClient: {
                first_name: null,
                last_name: null,
                parent_email: null,
            },
            filteredUserClientsByOrganization: [],
            loading: false,
            selectedAssignee: null,
            modal: {},
            modals: [
                {
                    visible: false,
                    size: "sm",
                    title: "Add Client",
                    type: 0,
                },
                {
                    visible: false,
                    size: "null",
                    title: "Client Details",
                    type: 1,
                },
                {},
                {
                    visible: false,
                    size: "sm",
                    title: "Choose an action",
                    type: 3,
                },
                {
                    visible: false,
                    size: "null",
                    title: "An error has occurred",
                    type: 4,
                },
            ],
            filterString: "",
            isAddClientFromOrgModalVisible: false,
            isAssignResourceVisible: false,
            errorMessage: null,
        };
    },
    created() {
        this.$bus.$on("update-resource", () => this.fetchFilteredUserClientsByOrganization());
    },
    watch: {
        organization() {
            if (this.organization) {
                this.fetchFilteredUserClientsByOrganization();
            }
        },
        filteredUserClientsByOrganization: {
            immediate: false,
            handler: function() {
                if (this.selectedAssignee) {
                    const therapists = this.filteredUserClientsByOrganization.find(
                        c => c.id === this.selectedAssignee.id
                    ).therapists;
                    this.$set(this.selectedAssignee, "therapists", therapists);
                }
            },
        },
    },

    methods: {
        fetchFilteredUserClientsByOrganization() {
            let params = { params: { organization_id: this.organization.id } };
            axios.get("/api/patients", params).then(r => {
                this.filteredUserClientsByOrganization = r.data.data;
            });
        },
        showAddClientModal() {
            if (!this.canAddClient) return;
            this.newClient = {};
            this.modal = this.modals[0];
            this.modal.visible = true;
        },

        showAddClientFromOrgModal() {
            if (!this.canAddClient) return;
            this.isAddClientFromOrgModalVisible = true;
        },

        hideAddClientFromOrgModal() {
            this.isAddClientFromOrgModalVisible = false;
            this.fetchFilteredUserClientsByOrganization();
        },

        resetModal() {
            this.modal = {};
            this.modal.visible = false;
            this.selectedAssignee = null;
            this.errorMessage = null;
        },
        confirmDelete(assignee) {
            this.promptDelete(assignee);
        },
        detailsClient(client) {
            this.resetModal();
            this.selectedAssignee = client;
            this.modal = this.modals[1];
            this.modal.visible = true;
        },
        showContextMenu(client) {
            this.resetModal();
            this.selectedAssignee = client;
            this.modal = this.modals[3];
            this.modal.visible = true;
        },
        showError(error) {
            this.resetModal();
            this.errorMessage = error;
            this.modal = this.modals[4];
            this.modal.visible = true;
        },
        detachClient(patient) {
            if (!this.canAddClient) return;
            this.loading = true;
            axios
                .delete("/api/users/" + this.user.id + "/patient/" + patient.id)
                .then(response => {
                    this.loading = false;
                    this.resetModal();
                    this.fetchFilteredUserClientsByOrganization();
                })
                .catch(error => {
                    this.loading = false;
                    console.error(error);
                    if (error.response) {
                        this.showError(error.response.status);
                    }
                });
        },
        deleteClient(patient) {
            if (!this.canAddClient) return;
            let payload = { data: { organization_id: this.organization.id } };
            axios
                .delete("/api/patients/" + patient.id, payload)
                .then(response => {
                    this.loading = false;
                    this.resetDelete();
                    this.fetchFilteredUserClientsByOrganization();
                })
                .catch(error => {
                    this.loading = false;
                    console.error(error);
                    this.resetDelete();
                    if (error.response) {
                        this.showError(error.response.status);
                    }
                });
        },

        validateClient(client) {
            return client.first_name && client.last_name;
        },

        updateClient() {
            this.loading = true;
            let payload = {};
            ["first_name", "last_name", "parent_email"].forEach(f => {
                //Fields from the edit client form
                payload[f] = { ...this.selectedAssignee }[f];
            });
            if (!this.validateClient(payload)) {
                this.loading = false;
                return;
            }
            payload.organization_id = this.organization.id;
            payload.user_id = this.user.id;
            if (payload.parent_email) {
                this.sendTeamInvite(payload.parent_email);
            }
            axios
                .patch("/api/patients/" + this.selectedAssignee.id, payload)
                .then(response => {
                    this.loading = false;
                    this.resetModal();
                    this.fetchFilteredUserClientsByOrganization();
                })
                .catch(error => {
                    this.loading = false;
                    console.error(error);
                    if (error.response) {
                        this.showError(error.response.status);
                    }
                });
        },
        createClient() {
            if (!this.canAddClient) return;
            this.loading = true;
            let payload = { ...this.newClient };
            if (!this.validateClient(payload)) {
                this.loading = false;
                return;
            }
            payload.organization_id = this.organization.id;
            payload.user_id = this.user.id;
            if (payload.parent_email) {
                this.sendTeamInvite(payload.parent_email);
            }
            axios
                .post("/api/patients", payload)
                .then(response => {
                    mixpanel.track("My Connections - Add new client", {
                        "Parent Email": payload.parent_email ? true : false,
                    });
                    window.location.reload(); //TODO: update dynamically
                    this.loading = false;
                    this.$emit("refresh-clients");
                    this.resetModal();
                    this.fetchFilteredUserClientsByOrganization();
                })
                .catch(error => {
                    this.loading = false;
                    console.error(error);
                    if (error.response) {
                        if (error.response.status === 422) {
                            this.showError(
                                error.response.status +
                                    " - A patient with this name already exists, please enter a unique name."
                            );
                        } else {
                            this.showError(error.response.status);
                        }
                    }
                });
        },
        sendTeamInvite(email) {
            /*axios.post(`/api/...`, email).then(r=>{

                }).catch(e=>{
                    console.error(e)
                })*/
        },

        showAssignResource(assignee) {
            this.$set(this, "selectedAssignee", assignee);
            this.isAssignResourceVisible = true;
        },

        hideAssignResource() {
            this.$set(this, "selectedAssignee", null);
            this.isAssignResourceVisible = false;
        },
    },
};
</script>

<style scoped lang="scss">
.client-image {
    width: 64px;
    height: 64px;
}

.details {
    > p {
        font-size: 100%;
    }
}

.list-item {
    border: solid 1px #bfbfbf;
}

li {
    font-size: 100%;
    background-color: white;
}

a.dropdown-item {
    font-size: 80%;
    background-color: white;
}

a.dropdown-item:hover {
    background-color: #afd4ee;
    color: white;
}

a.dropdown-item:focus {
    background-color: #afd4ee;
    color: white;
}

.bg-lightblue {
    background-color: #afd4ee;
}

.actions:hover {
    background-color: #d64571 !important;
    color: white !important;
}

#filter-string::placeholder {
    font-style: italic;
    color: lightgray;
}
</style>
